import createStyles from '@material-ui/core/styles/createStyles'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Theme } from '@material-ui/core/styles'

export const styles = ({ palette, spacing, shadows }: Theme) =>
  createStyles({
    form: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'space-between',
    },
    select: {
      width: spacing(20),
      height: spacing(5),
      color: `${palette.trunkrs.primary.indigo.base} `,
    },
    selectMedium: {
      width: spacing(25),
      height: spacing(7),
    },
    selectFullWidth: {
      width: '100%',
    },
    label: {
      margin: 0,
      alignItems: 'flex-start',
      fontWeight: 'bold',
      fontSize: 12,
      lineHeight: '20px',
    },
    placeholderTextColor: {
      color: palette.trunkrs.grayscale.theBeast,
    },
    dropDownIcon: {
      marginRight: spacing(1),
      fontSize: 24,
    },
    icon: {
      width: 20,
      height: 20,
    },
    paper: {
      padding: spacing(0.5),
      border: `1px solid ${palette.trunkrs.grayscale.base}`,
      borderRadius: 0,
      boxShadow: shadows[1],
      overflow: 'hidden',
      marginTop: -5,
    },
    list: {
      padding: 0,
    },
    placeholderHidden: {
      display: 'none',
    },
    disabled: {
      color: palette.trunkrs.grayscale.base,
    },
    error: {
      '--box-shadow-color': palette.trunkrs.intent.red.base,
      '--box-shadow-size': '2px',
    },
    warning: {
      '--box-shadow-color': palette.trunkrs.intent.orange.base,
      '--box-shadow-size': '2px',
    },
    success: {
      '--box-shadow-color': palette.trunkrs.primary.green.base,
      '--box-shadow-size': '2px',
    },
  })

export default makeStyles(styles)
